import { CORRELATION_CARD, EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, SIMPLE_CARD } from "src/sections/GroupCards/cardTypes";
import { ChartManager } from "..";

const states = {
  [SIMPLE_CARD]: [],
  [MULTIPLE_CARD]: [],
  [SIMPLECROSS_CARD]: [],
  [EVOLUTIVE_CARD]: [],
  [EVOLUTIVE_CROSS_CARD]: [],
  [CORRELATION_CARD]: [],
};

/**
 * Controla o estado das legendas visíveis nos gráficos, por exemplo, no gráfico de barras do card simples, ele terá o estado
 * armazenado em um array ['Legenda A', 'Legenda B'], e isso representa as legendas que estão atualmente desabilitadas
 * neste gráfico.
 * @param {ChartManager} managerRereference
 */
export const useLegendHandler = function (managerRereference) {
  const identifier = managerRereference.getCardType();

  let state;

  const updateState = (eventCtx) => {
    if (state) {
      const { name, selected } = eventCtx;
      const isDisabled = !selected[name];

      if (isDisabled && !state.includes(name)) {
        state.push(name);
      } else if (!isDisabled && state.includes(name)) {
        state.splice(state.indexOf(name), 1);
      }
    }
  };

  state = states[identifier];

  return {
    state: state,
    update: updateState,
  };
};

export const resetChartLegendsState = function(card) {
  states[card].length = 0;
}
